import { render, staticRenderFns } from "./RedmineCustomFieldInput.vue?vue&type=template&id=70eaa38d&scoped=true"
import script from "./RedmineCustomFieldInput.vue?vue&type=script&lang=js"
export * from "./RedmineCustomFieldInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eaa38d",
  null
  
)

export default component.exports